<div class="payment-options-wrapper" [class.arebic-content]="textDirection == 'rtl'">
    <div class="payment-option-title">
        <h4 translate>LEARN_MORE_PAGE.HOW_DOES</h4>
    </div>
    <div class="payment-option-tab" >
        <p-tabView>
            <p-tabPanel >
                <ng-template pTemplate="header" >
                    <span translate>LEARN_MORE_PAGE.WITHOUT_TALY</span>
                
                </ng-template>
                <div class="tab-content">
                    <taly-without-taly />
                </div>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header" >
                    <span translate>
                        LEARN_MORE_PAGE.WITH_TALY
                    </span>
                </ng-template>
                <div class="tab-content">
                    <taly-with-taly />
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>